import React, {useState, useEffect} from 'react'
import socialService from '../../services/socialapi';
import {getAccessToken} from '../../services/accessToken'


const ProfileUploadedPictures = ({isHidden,userId}) => {
    console.log("the uploaded items from user")
    const [items, setItems] = useState([])
    
    
    useEffect(() => {
        console.log("loading items for profile wardrobe")
        const token = getAccessToken()
        console.log("PROFILE TOKEN", token)
        socialService.getSocialUserContent(token).then(x => {
            console.log("got the personal items", x)
            setItems(x)
        })
    }, [])
    
    console.log(userId)
    console.log("the items", items)
    return (
        <>
            <div className={`${isHidden ? "block" : "hidden"} block min-h-screen p-4`}>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 auto-rows-auto">
                    {items.map((x) => {
                        return (
                            <>
                                <div className="h-40 w-40 md:h-60 md:w-60 cursor-pointer rounded-full  " >
                                    <img className="rounded-lg  h-full w-full object-cover " src={`https://polar-castle-07148.herokuapp.com/api/social/images/socialfeed/${userId}/${x.postImage}`}/>
                                </div>
                            </>
                        )
                    })}
                    
                </div>
            </div>
            
        </>
    )
}

export default ProfileUploadedPictures